import { Box, Burger, Drawer } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { NavbarConfiguration, NavbarSearch } from "./navbar/Navbar";
import { Outlet } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";

const useStyles = createStyles((theme) => ({
  hiddenMobile: {
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      display: "none",
    },
  },

  hiddenDesktop: {
    [`@media (min-width: ${theme.breakpoints.sm})`]: {
      display: "none",
    },
  },

  burger: {
    [`@media (min-width: ${theme.breakpoints.xs})`]: {
      display: "none",
    },
  },
}));

export interface ServiceWithMenuLayerProps {
  navbarConfiguration: NavbarConfiguration;
}

export const ServiceWithMenuLayer = ({
  navbarConfiguration,
}: ServiceWithMenuLayerProps) => {
  const { classes, theme } = useStyles();
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);

  return (
    <div style={{ display: "flex", zIndex: 0, position: "relative" }}>
      <Burger
        opened={drawerOpened}
        onClick={toggleDrawer}
        className={classes.hiddenDesktop}
      />
      <div className={classes.hiddenMobile}>
        <NavbarSearch configuration={navbarConfiguration} />
      </div>
      <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size="100%"
        padding="md"
        title="Navigation"
        className={classes.hiddenDesktop}
        zIndex={1000000}
      >
        <NavbarSearch
          onLinkClick={() => closeDrawer()}
          configuration={navbarConfiguration}
        />
      </Drawer>
      <Box
        style={{
          flex: 1,
          minWidth: 0,
          padding: "var(--mantine-spacing-md)",
        }}
      >
        <Outlet />
      </Box>
    </div>
  );
};
